import { render } from "./bill-detail.vue?vue&type=template&id=6de973a5&scoped=true&ts=true"
import script from "./bill-detail.vue?vue&type=script&lang=ts"
export * from "./bill-detail.vue?vue&type=script&lang=ts"

import "./bill-detail.vue?vue&type=style&index=0&id=6de973a5&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de973a5"]])

export default __exports__